import { useToastStore, type ToastTone } from '../../stores/toast.store';
import { Icon, type IconName } from './Icon';

const ICON_BY_TONE: Record<ToastTone, IconName> = {
  ok: 'check',
  info: 'bell',
  warn: 'alert',
  alert: 'alert',
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  if (!toasts.length) return null;
  return (
    <div className="toaster" role="region" aria-live="polite" aria-label="Notifiche">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.tone}`}>
          <div className="toast-icon"><Icon name={ICON_BY_TONE[t.tone]} size={14} draw={t.tone === 'ok'} /></div>
          <div className="toast-body">
            <div className="toast-title">{t.title}</div>
            {t.description && <div className="toast-desc">{t.description}</div>}
          </div>
          {t.action && (
            <button
              className="toast-action"
              onClick={() => { t.action!.onClick(); }}
            >
              {t.action.label}
            </button>
          )}
          <button className="toast-close" onClick={() => dismiss(t.id)} aria-label="Chiudi notifica">
            <Icon name="x" size={12} />
          </button>
        </div>
      ))}
    </div>
  );
}
